import React , {useState, useEffect, useCallback} from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Slider from 'react-slick';
import ProductPopup from '../components/popup/ProductPopup'
import SolutionPopup from '../components/popup/SolutionPopup'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'


const Solutions = () =>{
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL; 

  const [openProduct, setOpenProduct] = useState(false);
  const [openSolution, setOpenSolution] = useState(false);
  const [enquiry, setEnquiry] = useState('');


  const [pagedata, setPagedata] = useState('');
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')  
  const [widgetdata, setWidgetdata] = useState('');
  const [parentdata, setParentdata] = useState([]);
  const [solution, setSolution] = useState([]);
  const apiUrl = apiBaseUrl+`solutionpage`;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],          
  };   

  const callEnquiry = (txt) =>{
    setEnquiry(txt);
    if(txt === 'Service Enquiry'){
        setOpenProduct(true);
        setOpenSolution(false);
    }else{
        setOpenProduct(false);
        setOpenSolution(true);
    }
  }

  const fetchInfo = useCallback(() => {
    return axios.get(apiUrl).then((res) => {
      setPagedata(res.data.page);
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setWidgetdata(res.data.solutionwidget)
      setParentdata(res.data.parentsolwidget)
      setSolution(res.data.allsolutions)
    });
  },[]);

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
      setLoading(false);
    }, 2000);
  }, [fetchInfo]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 
  
 
  return (
    <>
    <Header/>

    { loading && ( <Loader /> )}

    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{pagedata?.name}</p>
                        <h2 className="heading col-lg-offset-2 col-lg-8 col-sm-12">{pagedata?.page_heading}</h2>
                        <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{pagedata?.short_description}</p>
                    </div>               
                </div> 
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="Products">
                        {pagedata?.image && (
                            <img src={`${siteUrl}${pagedata?.image}`} alt={pagedata?.name} /> 
                        )}
                    </div>                            
                </div> 
            </div>
        </div> 
    </section>
    
    <div className="container"><hr /></div>
    
    <section className="section-content-block">
        <div className="container wow fadeIn animated" style = {{ visibility: "visible", animationName: "fadeIn"}}>
            <div className="row">
                <div className="col-md-offset-2 col-md-8 col-sm-12 text-center">    
                    <p className="our-experience">{widgetdata?.heading}</p>
                    <div className="about-us-intro">{widgetdata?.description}</div>                            
                </div>
            </div>
            <div className="row text-center margin-top-32 solar-advantage ">

                {parentdata.map((item,index) => {
                    return(
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12" key={index}> 
                            <div className="Solar">
                                <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                                <h2>{item?.name}</h2>
                            </div>
                        </div>
                    )
                })}
                    
            </div>
        </div>       
    </section>

    {solution.map((item, index)=> {
        return(
        <div key={index}>
            <div id={item?.hash_link} className="container vertiocal-gap-1001"><hr /></div>
            <section className="section-content-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">                       
                            <div className="about-us-intro">
                                <p className="blue">{item?.name}</p>
                                <h2 className="heading col-lg-10 pl-0">{item?.heading}</h2>
                                <p className='col-sm-12 pl-0'>{item?.description}</p>                            
                                <button 
                                    className="btn btn-button margin-top-60" 
                                    onClick={() => callEnquiry(`${item?.call_enquiry}`)}>Enquire now
                                </button>                          
                            </div>                            
                        </div> 
                        <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                            <img src={`${siteUrl}${item?.image}`} className='fullwidth' alt={item?.name} />               
                        </div>
                    </div>
                </div> 
            </section>
        {(item?.solution_project.length > 0) && (
            <section className="section-content-block bg-gray">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                            <div className="about-us-intro">
                                <p className="our-experience">{item?.feature_heading}</p>
                                <p>{item?.feature_content}</p>
                            </div>                            
                        </div>
                    </div>
                    <div className="row pb-100 ">
                        <div className="one-carousel col-sm-12 owl-carousel1">

                            <Slider {...settings}>
                            {item?.solution_project.map((item1, index1) => {
                                return (                                       
                                <div className="" key={index1}>                       
                                    <div className="Products projects">
                                        <img src={`${siteUrl}${item1?.image}`} alt={item1?.name} /> 
                                        <div className="project-des">
                                            <h4 className="heading">{item1?.name}</h4>
                                            <h5>{item1?.location}</h5>
                                            <p>{item1?.description}</p>
                                        </div>	
                                    </div>                            
                                </div>
                                );
                            })}                                
                            
                            </Slider>                            
                        </div>
                    </div>
                </div>
            </section>
        )}

        </div>
        )
    })}

    {openProduct ? <ProductPopup prm={enquiry} closePopup={() => setOpenProduct(false)} /> : null}
    {openSolution ? <SolutionPopup prm={enquiry} closePopup={() => setOpenSolution(false)} /> : null}	
    
    <Footer/>    
    </>
  )
}

export default Solutions